export default function Footer() {
  return (
    <footer className="footer-links">
      <a href="mailto:support@elo-board.com">Contact</a>
      <span className="separator">|</span>

      <a href="https://elo-board.com/PrivacyPolicy">Privacy Policy</a>


    </footer>
  )
}
